export default __webpack_public_path__ + "static/media/cascara.2e2d4500.svg";